export default "__VITE_ASSET__D7tsd_s$__"